import React from "react";

import { connect } from "react-redux";
import {
  Panel,
  PanelHeader,
  PanelHeaderBack,
  ScreenSpinner,
  SimpleCell,
  Div,
} from "@vkontakte/vkui";
import Icon24Done from "@vkontakte/icons/dist/24/done";
import styles from "./MedicalOrganisationSelector.style";
import { setPreviousPanel } from "../../redux/actions/panelsActions";
import { selectMedicalOrganisation } from "../../redux/actions/regionAndMedicalOrganisationActions";

const MedicalOrganisationSelector = ({
  id,
  medicalOrganisations,
  selectedMedialOrganisation,
  goBack,
  selectMedicalOrganisation,
}) => {
  const mapMedicalOrganisationToSimpleCell = (medicalOrganisation) => {
    return (
      <SimpleCell
        style={styles.medicalOrganisation}
        key={medicalOrganisation.value}
        onClick={() => {
          selectMedicalOrganisation(medicalOrganisation);
          goBack();
        }}
        after={
          selectedMedialOrganisation &&
          selectedMedialOrganisation.attributeValues.Organization_Name ===
            medicalOrganisation.attributeValues.Organization_Name ? (
            <Icon24Done fill="var(--accent)" />
          ) : null
        }
        description={getShortAddress(
          medicalOrganisation.attributeValues.Address_MO
        )}
      >
        {getShortNameFromFull(
          medicalOrganisation.attributeValues.Organization_Name
        )}
      </SimpleCell>
    );
  };
  const getShortAddress = (address) => {
    const addressWithoutIndex = address.slice(8);
    const commaIndex = addressWithoutIndex.indexOf(",");
    return addressWithoutIndex
      .split("")
      .slice(commaIndex + 1)
      .join("");
  };

  const getShortNameFromFull = (fullName) => {
    while (fullName.includes(",")) {
      fullName = fullName.replace(",", "");
    }
    const words = fullName.split(" ");
    return words.slice(0, 4).join(" ");
  };
  return (
    <Panel id={id}>
      <PanelHeader left={<PanelHeaderBack onClick={() => goBack()} />}>
        <span style={styles.blue}>ГОС</span>
        <span style={styles.red}>УСЛУГИ</span>
      </PanelHeader>
      {medicalOrganisations.length ? (
        medicalOrganisations.map(mapMedicalOrganisationToSimpleCell)
      ) : (
        <Div style={{ marginTop: "40vh" }}>
          <ScreenSpinner />
        </Div>
      )}
    </Panel>
  );
};

const mapStateToProps = (state) => {
  return {
    medicalOrganisations:
      state.regionAndMedicalOrganisation.medicalOrganisations,
    selectedMedialOrganisation:
      state.regionAndMedicalOrganisation.selectedMedicalOrganisation,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goBack: () => dispatch(setPreviousPanel()),
    selectMedicalOrganisation: (medicalOrganisation) =>
      dispatch(selectMedicalOrganisation(medicalOrganisation)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MedicalOrganisationSelector);
